export const remoteFuncsObj = {
  func_test(resolve) {
    setTimeout(() => {
      const options = [
        { id: '1', name: '1111' },
        { id: '2', name: '2222' },
        { id: '3', name: '3333' },
      ]

      resolve(options)
    }, 2000)
  },
  funcGetToken() {
    /* request.get('http://tools-server.xiaoyaoji.cn/api/uptoken').then(res => {
           resolve(res.uptoken)
         }) */
  },
  func_cascader(resolve) {
    const navi = ''
    const options = navi
    resolve(options)
  },
  upload_callback() {
    // console.log('callback', response, file, fileList)
  },
}
